// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TMu6","col":"styles_col__3G7sH"};